interface Props extends React.ComponentProps<"div"> {}

export function BaseTooltip(props: Props) {
  const { children } = props;
  return <div className="rounded bg-gray-800 p-4 text-gray-50">{children}</div>;
}
